import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'

const getHomePage = async (token) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "homeP",{token});
    return (dFromF);
}

const updateHomePage = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "homeP/" + obj._id, obj);
    return (dFromF);
}

const getMainRests = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "homeP/mainRests");
    return (dFromF);
}


const getFavoRests = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "homeP/favoRests");
    return (dFromF);
}



export default {
    getHomePage,
    updateHomePage,
    getMainRests,
    getFavoRests
};